type Props = { score: number; label: string };

function formatConvictionOver10(raw: number): string {
  if (!Number.isFinite(raw) || raw <= 0) return "0.0";
  const v = raw <= 1 ? raw * 10 : raw;
  const clamped = Math.max(0, Math.min(10, v));
  return clamped.toFixed(1);
}

export function ConfidenceLCD({ score, label }: Props) {
  const value = formatConvictionOver10(score);

  return (
    <div
      data-testid="confidence-lcd"
      style={{
        position: "relative",
        background: "var(--qv3-ink)",
        border: "1px solid var(--qv3-gold)",
        padding: "18px 24px",
        overflow: "hidden",
        marginBottom: 40,
      }}
    >
      <div
        data-rp="confidence-lcd-inner"
        style={{
          border: "0.5px solid var(--qv3-gold-soft)",
          padding: "14px 28px",
          background: "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 14,
          fontFamily: "var(--qv3-font-mono)",
          fontSize: 12,
          letterSpacing: 4,
          textTransform: "uppercase",
          color: "var(--qv3-gold)",
        }}
      >
        <span>Indice de confiance</span>
        <span style={{ color: "var(--qv3-gold-soft)" }}>·</span>
        <span data-testid="confidence-value" style={{ color: "var(--qv3-paper)", fontWeight: 500 }}>
          {value} / 10
        </span>
        <span style={{ color: "var(--qv3-gold-soft)" }}>·</span>
        <span style={{ color: "var(--qv3-paper)" }}>{label}</span>
      </div>
    </div>
  );
}

export default ConfidenceLCD;
